import {Pipe, PipeTransform} from '@angular/core';
import {Product} from "../models/product";

@Pipe({
  name: 'productPipe'
})
export class ProductPipe implements PipeTransform {
  transform(product: Product): string {
    return product.name + "<br/><small>" + product.code + " </small>" ;
  }
}
